import { Props } from './Layout'
import { useProps as useGlobalNavigationHeaderProps } from '../../parts/commons/GlobalNavigationHeader/useProps'
import { useRouter } from 'next/router'
import { PagePathService } from '../../../services/PagePathService'
export const useProps = (): Props => {
  const router = useRouter()
  return {
    onClickLoginButton: () => router.push(PagePathService.login()),
    onClickSignUpButton: () => router.push(PagePathService.signup()),
    GlobalNavigationHeaderProps: useGlobalNavigationHeaderProps(),
  }
}
